//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'HEMORR',
  data() {
    return {
      defaultJson: {
        "Anemia": "贫血",
        "Prior Stroke": "既往脑卒中史",
        "Alcohol Abuse": "酗酒",
        "Uncontrolled Hypertension": "未控制的高血压",
        "Age > 75 years": "年龄 > 75 岁",
        "Bleeding Rate": "出血概率",
        "Hepatic or Renal Disease": "肝病或肾病",
        "Malignancy": "恶性肿瘤",
        "Excessive Fall Risk": "极高的跌倒风险",
        "Reduced Platelet Count or Fx": "血小板计数或功能降低",
        "Prior Major Bleed": "既往大出血史"
      },
      form: {
        ageOver75: '0',
        priorMajorBleed: '0',
        hepaticOrRenalDisease: '0',
        alcoholAbuse: '0',
        malignancy: '0',
        hypertension: '0',
        anemia: '0',
        fallRisk: '0',
        priorStroke: '0',
        platelet: '0'
      },
      disabled: false,
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    prent() {
      if (this.score < 1) {
        return 1.9
      } else if (this.score < 2) {
        return 2.5
      } else if (this.score < 3) {
        return 5.3
      } else if (this.score < 4) {
        return 8.4
      } else if (this.score < 5) {
        return 10.4
      } else {
        return 12.3
      }
    },
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      // ageOver75 + priorMajorBleed + hepaticOrRenalDisease + clinic + duration
      let result = form.ageOver75 + (form.priorMajorBleed ? 2 : 0) + form.hepaticOrRenalDisease + form.alcoholAbuse + form.malignancy + form.hypertension + form.anemia + form.fallRisk + form.priorStroke + form.platelet

      return String(result)
    }
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/NewFormulas/HEMORR.vue